import { RenderedProductTableTitle } from "../product";

export const RenderedSubProductTableTitle = RenderedProductTableTitle;
